import { apiRequest } from "@/services/api/apiClient.js";

// Expect window.API_QRCODE to be configured in the environment

// Campaigns
export function listCampaigns(params = {}) {
  return apiRequest({ client: window.API_QRCODE, method: 'get', url: '/qrcode-campaign', params });
}
export function createCampaign(data) {
  return apiRequest({ client: window.API_QRCODE, method: 'post', url: '/qrcode-campaign', body: data });
}
export function getCampaign(id) {
  return apiRequest({ client: window.API_QRCODE, method: 'get', url: `/qrcode-campaign/${id}` });
}
export function updateCampaign(id, data) {
  return apiRequest({ client: window.API_QRCODE, method: 'put', url: `/qrcode-campaign/${id}`, body: data });
}
export function deleteCampaign(id) {
  return apiRequest({ client: window.API_QRCODE, method: 'delete', url: `/qrcode-campaign/${id}` });
}

// Categories
export function listCategories(params = {}) {
  return apiRequest({ client: window.API_QRCODE, method: 'get', url: '/qrcode-category', params });
}
export function createCategory(data) {
  return apiRequest({ client: window.API_QRCODE, method: 'post', url: '/qrcode-category', body: data });
}
export function getCategory(id) {
  return apiRequest({ client: window.API_QRCODE, method: 'get', url: `/qrcode-category/${id}` });
}
export function updateCategory(id, data) {
  return apiRequest({ client: window.API_QRCODE, method: 'put', url: `/qrcode-category/${id}`, body: data });
}
export function deleteCategory(id) {
  return apiRequest({ client: window.API_QRCODE, method: 'delete', url: `/qrcode-category/${id}` });
}

// Logos (existing in API)
export function listLogos(params = {}) {
  return apiRequest({ client: window.API_QRCODE, method: 'get', url: '/qrcode-logo', params });
}
export function createLogo(formData) {
  return apiRequest({ client: window.API_QRCODE, method: 'post', url: '/qrcode-logo', body: formData});
}
export function getLogo(id) {
  return apiRequest({ client: window.API_QRCODE, method: 'get', url: `/qrcode-logo/${id}` });
}
export function updateLogo(id, formData) {
  return apiRequest({ client: window.API_QRCODE, method: 'put', url: `/qrcode-logo/${id}`, body: formData });
}
export function deleteLogo(id) {
  return apiRequest({ client: window.API_QRCODE, method: 'delete', url: `/qrcode-logo/${id}` });
}

// URLs (QR Codes)
export function listQRCodes(params = {}) {
  return apiRequest({ client: window.API_QRCODE, method: 'get', url: '/qrcode', params });
}
export function createQRCode(data) {
  return apiRequest({ client: window.API_QRCODE, method: 'post', url: '/qrcode', body: data });
}
export function getQRCode(id) {
  return apiRequest({ client: window.API_QRCODE, method: 'get', url: `/qrcode/${id}` });
}
export function updateQRCode(id, data) {
  return apiRequest({ client: window.API_QRCODE, method: 'put', url: `/qrcode/${id}`, body: data });
}
export function deleteQRCode(id) {
  return apiRequest({ client: window.API_QRCODE, method: 'delete', url: `/qrcode/${id}` });
}
